(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sisna-christmas-set"] && !Shopify.designMode) return;
  try {
    
function initSisnaBundles(scope=document){
 scope.querySelectorAll('[data-sisna-bundle]').forEach(root=>{
  if(root.dataset.ready) return; root.dataset.ready='true';
  const form=root.querySelector('form'),selects=[...form.querySelectorAll('select')],button=form.querySelector('button'),error=form.querySelector('[role=alert]'),original=button.innerHTML;
  const money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:root.dataset.currency||'USD'});
  const messageInput=form.querySelector('textarea'),counter=form.querySelector('[data-message-count]');
  if(messageInput)messageInput.addEventListener('input',()=>{messageInput.value=messageInput.value.slice(0,80);counter.textContent=messageInput.value.length+' / 80';});
  if(!root.dataset.variant){button.disabled=true;button.textContent=root.dataset.unavailable;}
  selects.forEach(select=>select.addEventListener('change',()=>{
   const option=select.selectedOptions[0],img=select.parentElement.querySelector('img');
   img.src=option.dataset.image;img.alt=option.dataset.title;img.hidden=false;
   root.querySelector('[data-total]').textContent=money.format(Number(root.dataset.price)/100);
  }));
  form.addEventListener('submit',async e=>{
   e.preventDefault();if(!form.reportValidity()||!root.dataset.variant)return;
   error.hidden=true;button.disabled=true;button.textContent=root.dataset.adding;
   const large=root.dataset.count==='2';
   const group='SISNA-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,7);
   const message=form.querySelector('textarea')?.value.slice(0,80).trim();
   const properties={'Christmas set':large?'Gift Set · 2 full-size floral clips':'Everyday Set · 1 full-size floral clip','Set reference':group,'Complimentary gifts':large?'6 mini claw clips + 1 floral bag per complete set':'6 mini claw clips per complete set','_sisna_set_size':root.dataset.count};
   if(message)properties['Gift message']=message;
   selects.forEach((s,index)=>{properties['Full-size clip '+(index+1)]=s.selectedOptions[0].textContent.trim();properties['_clip_variant_'+(index+1)]=s.value;});
   const items=[{id:Number(root.dataset.variant),quantity:1,properties}];
   try{
    const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
    const result=await response.json();
    if(!response.ok)throw new Error(result.description||result.message||root.dataset.error);
    window.location.assign((window.Shopify?.routes?.root||'/')+'cart');
   }catch(err){error.textContent=err.message||root.dataset.error;error.hidden=false;button.disabled=false;button.innerHTML=original;}
  });
 });
}
initSisnaBundles();
document.addEventListener('shopify:section:load',e=>initSisnaBundles(e.target));

  } catch(e) { console.error(e); }
})();
})();
